import React from 'react';
import CompanyCategoryEditor from '../../../components/company-category-editor';

const CompanyCategoryEditorRoute = (props) => (
  <CompanyCategoryEditor {...props}/>
);

export default CompanyCategoryEditorRoute;
